import { Navigate } from 'react-router';
import { useIsMobile } from '../utils/responsive';

const FarmIndexView = () => {
  const isMobile = useIsMobile();
  // Redirect to the appropriate view for mobile/desktop
  return <Navigate to={isMobile ? 'map' : 'fields'} />;
};

export default FarmIndexView;
